import Mail from '@/generated/classes/Mail';
export default class MailExtend extends Mail {
  constructor() {
    super();
  }
}
